import arrowIcon from '@raison/static/icons/arrow-right-s-line.svg';
import React from 'react';
import {verificationMethods, VerificationMethodType} from '~/features/two-factor';
import {InlineSvg, RsnDialog} from '~/library/ui-kit';
import smsIcon from './icons/sms.svg';
import tgIcon from './icons/tg.svg';
import waIcon from './icons/wa.svg';

export type VerificationMethodDialog = {
    methods: VerificationMethodType[];
    onChange: (method: VerificationMethodType) => void;
};

type Option = {type: VerificationMethodType; icon: string; label: string};

export function VerificationMethodDialog({onChange, methods}: VerificationMethodDialog) {
    const {onClose} = RsnDialog.useControls();

    const icons: Record<VerificationMethodType, string> = {
        telegram: tgIcon,
        whatsapp: waIcon,
        sms: smsIcon,
    };

    const allMethods: Option[] = verificationMethods.map(method => ({...method, icon: icons[method.type]}));

    const options = allMethods.filter(option => methods?.includes(option.type));

    return (
        <RsnDialog.Window>
            <RsnDialog.LeftHeader>Preferred verification method</RsnDialog.LeftHeader>
            <RsnDialog.Body>
                <div className={'flex flex-col gap-4'}>
                    {options.map(option => (
                        <button
                            key={option.type}
                            className={'flex cursor-pointer items-center gap-4'}
                            onClick={() => {
                                onClose();
                                onChange(option.type);
                            }}
                        >
                            <img src={option.icon} className={'size-9'} width={36} height={36} alt={option.label} />
                            <span className={'fv-text-xl-regular flex-1 text-start text-neutral-100'}>
                                {option.label}
                            </span>
                            <InlineSvg src={arrowIcon} className={'size-5 text-neutral-90'} />
                        </button>
                    ))}
                </div>
            </RsnDialog.Body>
        </RsnDialog.Window>
    );
}
